export const getInputNumberRangeErrorMessage = (min?: number, max?: number) => {
  if (min !== undefined && max !== undefined) {
    return `Please enter a number between ${min} and ${max}`;
  }

  if (min !== undefined) {
    return `Please enter a number equal to or above ${min}`;
  }

  if (max !== undefined) {
    return `Please enter a number equal to or below ${max}`;
  }

  return 'Please enter a number';
};

export const isInputNumberInRange = (value: unknown, min?: number, max?: number) => {
  const parsed = Number(value);

  if (!Number.isFinite(parsed)) {
    return false;
  }

  if (min !== undefined && parsed < min) {
    return false;
  }

  if (max !== undefined && parsed > max) {
    return false;
  }

  return true;
};
